import modalContent from './components/content';

export default {
	components: {
		modalContent,
	},
	data() {
		return {};
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		isForm: {
			type: Boolean,
			default: false,
		},
		isShow: {
			type: Boolean,
		},
	},
	watch: {
		isShow: {
			immediate: true,
			handler(v) {
				v ? this.show() : this.hide();
			},
		},
	},
	computed: {},
	methods: {
		show() {
			$(this.$el).modal('show');
		},
		hide() {
			$(this.$el).modal('hide');
		},
	},
	created() {},
	mounted() {
		$(this.$el).on('shown.bs.modal', () => this.$emit('show'));
		$(this.$el).on('hidden.bs.modal', () => this.$emit('hide'));

		$(this.$el)
			.find('form')
			.on('click', (e) => e.preventDefault());
	},
	template: `<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <modal-content :isForm="isForm">
                            <div class="modal-header" v-if="title">
                                <h5 class="modal-title">{{title}}</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" v-if="$slots.default">
                                <slot name="default"></slot>
                            </div>
                            <div class="modal-footer" v-if="$slots.footer">
                                <slot name="footer"></slot>
                            </div>
                        </modal-content>
                    </div>
                </div>`,
};
